import { render, staticRenderFns } from "./technological-uk.vue?vue&type=template&id=1ff8d993&scoped=true&"
import script from "./technological-uk.vue?vue&type=script&lang=js&"
export * from "./technological-uk.vue?vue&type=script&lang=js&"
import style0 from "./technological-uk.vue?vue&type=style&index=0&id=1ff8d993&scoped=true&lang=css&"
import style1 from "./technological-uk.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff8d993",
  null
  
)

export default component.exports